import React, { useRef, createContext } from "react";

export const RefContext = createContext(undefined);

export const RefProvider = ({ children }) => {
  const componentSize = useRef({});
  const fairValue = useRef(null);

  const refs = { componentSize, fairValue };

  return refs ? (
    <RefContext.Provider value={refs}>{children}</RefContext.Provider>
  ) : null;
};
